import { render, staticRenderFns } from "./LinkCrmModal.vue?vue&type=template&id=35d1278c&scoped=true&"
import script from "./LinkCrmModal.vue?vue&type=script&lang=js&"
export * from "./LinkCrmModal.vue?vue&type=script&lang=js&"
import style0 from "./LinkCrmModal.vue?vue&type=style&index=0&id=35d1278c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d1278c",
  null
  
)

export default component.exports